export const renderSplitPrice = (value: number) => {
    if (Number.isInteger(value)) {
        return value;
    } else return +value.toFixed(2);
};
